<div class="container">
  <app-header></app-header>
  <app-gstin-header></app-gstin-header>
</div>
<router-outlet></router-outlet>